/**
 * Promise 處理工具，提供類似 Go 的 error-first 風格
 * 參考：https://github.com/arthurfiorette/try
 */

export type PromiseResult<T> = [error: null, result: T] | [error: Error, result: null]

/**
 * 處理 Promise，返回 [error, result] 格式
 * @param promise 要處理的 Promise
 * @returns [error, result] 元組
 */
export async function promiseHandler<T>(promise: Promise<T>): Promise<PromiseResult<T>> {
  try {
    const result = await promise
    return [null, result]
  } catch (error) {
    return [error instanceof Error ? error : new Error(String(error)), null]
  }
}

/**
 * 同步版本的 promiseHandler，用於處理同步函數
 * @param fn 要執行的函數
 * @returns [error, result] 元組
 */
export function trySync<T>(fn: () => T): [error: null, result: T] | [error: Error, result: null] {
  try {
    const result = fn()
    return [null, result]
  } catch (error) {
    return [error instanceof Error ? error : new Error(String(error)), null]
  }
}
